import {Box, Flex, Text} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {CallBtn} from 'components/shared/support-buttons/components';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {Courier} from 'types';

interface IProps {
  courier: Courier;
  t: (term: TranslationKeys) => string;
}

export const CourierDataInfo: FC<IProps> = ({courier, t}) => {
  const courier_default_photo = '/courier-default-photo.svg';
  const numberPhone = '+37322899999';

  return (
    <IconBlock heading={courier?.first_name ?? 'Straus Courier'} icon={`${courier?.photo ?? courier_default_photo}`}>
      <Box borderBottom="1px solid" borderColor={colors.borderGray}>
        <Text color={colors.textGray} fontWeight={500} m="12px 0">
          {t('COURIER_SLOGAN')}
        </Text>
      </Box>
      <Flex mt="12px" alignItems="center">
        <Text mr="20px" fontWeight={600}>
          {t('COURIER_NUMBER_PHONE')}:
        </Text>
        <CallBtn innerTitle={numberPhone} t={t} phoneNumber={numberPhone} />
      </Flex>
      <Box w="full"></Box>
    </IconBlock>
  );
};
